/* eslint-disable no-nested-ternary */
import RoutingHeader from '@accountSettings/RoutingHeader/RoutingHeader';
import icon from '@assets/svg/account.svg';
import closeNoBackground from '@assets/svg/close-no-background.svg';
import greaterthanToggle from '@assets/svg/greater-than-toggle.svg';
import hamburger from '@assets/svg/hamburger-menu-icon.svg';
import lesserthanToggle from '@assets/svg/lesser-than-toggle.svg';
import {
    ApplicationFlowType,
    CredibilityEntitlement,
    ProfileDetails,
    VboEntitlement
} from '@customTypes/ItemTypes';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { sendGA4ClickEvent } from '@helpers/gtmUtils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useCountryCodeInfo from '@helpers/customHooks/useCountryCodeInfo';
import { getCancelRenewalURL } from '@helpers/getDashboardRedirectUrl';
import { setActivePartnerName } from '@redux/slices/appSlice';
import React, {
    useCallback, useEffect, useMemo, useState
} from 'react';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Translate } from 'react-redux-i18n';
import {
    Link,
    NavLink,
    useHistory,
    useLocation
} from 'react-router-dom';
import { isCountryCodeUS } from '@helpers/isEuropeRegion';
import {
    CANCEL_RENEWAL, ENABLE_LILI_FEATURES, ENABLE_NAVIGATE_DEEPLINK, ENABLE_NEW_LENDIO_FEATURES, ENABLE_NEXT_INSURANCE_FEATURES, MFA_FACTOR, ENABLE_NEW_DPM_FEATURES
} from '@helpers/constants';
import { magentoUrl, subscriptionMagentoUrl } from '../../../helpers/getDashboardRedirectUrl';
import { ProductNames } from '../EntitledProducts/constant';
import { BellNotification } from './BellNotification/BellNotification';
import { CompanyDropdownList } from './CompanyDropdownList';
import {
    countryCodes, partnerNameList, legalLLCUrl, FundabilityScanUrl, taxAndAccountingUrl
} from '../PageBottom/constants';
import './TopBar.scss';
import DnbLogo from '../../DnbLogo';
import InfoTooltip from '../../InfoTooltip/InfoTooltip';
import { useAppDispatch, useAppSelector } from '@redux/reduxHooks';
import { RootState } from '@redux/store';
import { useGetNavigateUrlMutation } from '@redux/services/api';

const TopBarComponent = () => {
    const { featuresList } = useCountryCodeInfo();
    const [getNavigateUrl] = useGetNavigateUrlMutation();
    const dispatch = useAppDispatch();
    const {
        isSupportEnabled, supportURL, isCancelRenewalEnabled, isCancelrenewalSupportThroughEmail,
        cancelRenewalURL, isLearningCenterEnabled, learningCenterURL, isDealsOffersEnabled
    } = featuresList;
    const [showMobileMenu, setShowMobileMenu] = useState(false);
    const accountSettings = useAppSelector((state: RootState) => state.app.accountSettings);
    const entitlements = useAppSelector((state: RootState) => state.app.entitlements);
    const profileDetails = useAppSelector((state: RootState) => state.app.profileDetails);
    const isMobile = useAppSelector((state: RootState) => state.app.isMobile);
    const isScreenWidthUnder600Pixel = useAppSelector((state: RootState) => state.app.isScreenWidthUnder600Pixel);
    const cancelRenewalURLQueryParams = btoa(unescape(encodeURIComponent(
        JSON.stringify({
            firstName: `${profileDetails?.firstName}`,
            lastName: `${profileDetails?.lastName}`,
            emailID: `${profileDetails?.email}`
        })
    )));
    const {
        credibilityEntitlements: credEntitlementList,
        vboEntitlements: vboEntitlementList,
        companyInfo: dunsList
    } = entitlements;

    let diplomaProductLists: any = [];
    if (vboEntitlementList?.length) {
        diplomaProductLists = vboEntitlementList.filter((entitle) => entitle.product_name === ProductNames?.AAADiploma);
    }

    const language_code = profileDetails.languagePreference || '';

    const [showSubMenu, setShowSubMenu] = useState(false);
    const toggleSubMenu = () => {
        console.log('Working', showSubMenu);
        setShowSubMenu(!showSubMenu);
    };
    const userCountryCode = profileDetails.countryCode;
    const history = useHistory();
    const enableNewLendioFeatures = ENABLE_NEW_LENDIO_FEATURES;
    const enableNextInsuranceFeatures = ENABLE_NEXT_INSURANCE_FEATURES;
    const enableLiliFeatures = ENABLE_LILI_FEATURES;
    const [selectedCompanyDunsNumber, setSelectedCompanyDunsNumber] = useState();
    const [showNotification, setShowNotification] = useState(false);
    const [openTooltipId, setOpenTooltipId] = useState<string | null>(null);

    const handleIsSmallBusinessFinancingClicked = () => {
        dispatch(setActivePartnerName(partnerNameList.lendio));
        sendGA4ClickEvent('linkTrackingEvent', { linkTrackingName: 'Small Business Financing Clicked' });
        setShowSubMenu(false);
        setShowMobileMenu(false);
    };
    const handleIsSmallBusinessInsuranceClicked = () => {
        dispatch(setActivePartnerName(partnerNameList.nextInsurance));
        sendGA4ClickEvent('linkTrackingEvent', { linkTrackingName: 'Small Business Insurance Clicked' });
        setShowSubMenu(false);
        setShowMobileMenu(false);
    };
    const handleIsSmallBusinessBankingClicked = () => {
        dispatch(setActivePartnerName(partnerNameList.lili));
        sendGA4ClickEvent('linkTrackingEvent', { linkTrackingName: 'Small Business Banking Clicked' });
        setShowSubMenu(false);
        setShowMobileMenu(false);
    };

    const handleIsLegalLLCFormationClicked = () => {
        sendGA4ClickEvent('linkTrackingEvent', { linkTrackingName: 'Legal LLC Formation Clicked' });
        window.open(legalLLCUrl, '_blank');
        setShowSubMenu(false);
        setShowMobileMenu(false);
    };
    const handleIsFundabilityScanClicked = () => {
        sendGA4ClickEvent('linkTrackingEvent', { linkTrackingName: 'Fundability Scan Clicked' });
        window.open(FundabilityScanUrl, '_blank');
        setShowSubMenu(false);
        setShowMobileMenu(false);
    };

    const handleIsTaxAndAccountingClicked = () => {
        sendGA4ClickEvent('linkTrackingEvent', { linkTrackingName: 'Tax and Accounting Clicked' });
        window.open(taxAndAccountingUrl, '_blank');
        setShowSubMenu(false);
        setShowMobileMenu(false);
    };
    const handleSelectedCompanyData = useCallback((selectedData: any) => {
        if (selectedData) {
            setSelectedCompanyDunsNumber(selectedData?.profileDetails?.dunsNumber);
        }
    }, []);

    const location = useLocation();

    // Display cancel renewal for all products including free products - US
    const displayCancelLink = (entitlementsVbo: VboEntitlement[], entitlementsCred: CredibilityEntitlement[]): boolean => {
        if (!entitlementsVbo && !entitlementsCred) return false;
        // filter out non EB dashboard product
        const ebFiltered = entitlementsVbo.filter((entitle) => entitle.product_name !== 'EB Dashboard');
        // if only EB dashboard hide it
        if (entitlementsVbo.length && ebFiltered.length == 0 && !entitlementsCred.length) return false;
        // if anyother product exists, don't hide it
        return true;
    };

    const bindDispatch = () => {
        setShowMobileMenu(false);
    };

    useEffect(() => {
        window.addEventListener('resize', bindDispatch);
        return () => window.removeEventListener('resize', bindDispatch);
    }, []);
    const CreditTab = (): JSX.Element => {
        const hasNavigate = useAppSelector((state: RootState) => state.app.hasNavigate);
        return (
            <>
                {ENABLE_NAVIGATE_DEEPLINK && hasNavigate.isNavigate && (
                    <div className={isMobile ? 'w-[95%] mr-[5px] mt-[5px] rounded-[5px] box-border font-semibold inline-flex desktop:mt-0 desktop:p-2.5 desktop:ml-[5px] desktop:font-[unset] desktop:border-0 desktop:[&>*]:p-[8px_8px_10px] desktop:[&>*:last-child]:p-0 hover:desktop:bg-light-gray-content hover:desktop:border-transparent hover:desktop:border-0 hover:desktop:rounded-[5px] hover:border-l-[5px] hover:border-r-0 hover:border-t-0 hover:border-b-0 hover:border-light-gray-content hover:rounded-none border-solid' : 'no-underline flex flex-row justify-center items-center px-4 static w-auto h-[61px] text-dnb-cpl-box-shadow z-20 not-italic font-normal text-sm leading-5 tracking-[01.px] cursor-pointer'}>
                        <a
                            onClick={() => sendGA4ClickEvent('linkTrackingEvent', { linkTrackingName: 'Credit Tab clicked' })}
                            href={hasNavigate?.deepLinkUrl}
                            className="navigation-item"
                            target="_self"
                            rel="noopener noreferrer"
                        >
                            <div className={isMobile ? 'text-dnb-cpl-box-shadow text-sm leading-5 h-[50px] desktop:h-5 px-[5px] flex items-center ml-5 mr-2.5' : ''}>
                                <Translate value="nav:credit" />
                            </div>
                        </a>
                    </div>
                )}
            </>
        );
    };

    const MarketingHubTab = (): JSX.Element => {
        const applicationState = useAppSelector((state: RootState) => state.app.applicationState);
        const dunsList = useAppSelector((state: RootState) => state.app.entitlements.companyInfo);
        const selectedCompanyDunsNumber = useAppSelector((state: RootState) => state.app.selectedCompanyInfo?.profileDetails.dunsNumber);

        const marketingHubLink = async () => {
            const {
                isDunsSelected, isAllProductsVBO, isCompanyDropDownOnlyAvailable, isCompanyDropDownWithOutAnyVBOProducts, deepLinkUrl, isProductDPM
            } = applicationState;
            sendGA4ClickEvent('linkTrackingEvent', { linkTrackingName: 'Marketing Hub Tab clicked' });
            // Zero DUNS flow or  ALL products are VBO
            if (ENABLE_NEW_DPM_FEATURES && ((!isDunsSelected && !isAllProductsVBO
                && !isCompanyDropDownOnlyAvailable && !isCompanyDropDownWithOutAnyVBOProducts && deepLinkUrl === '')
                || (isAllProductsVBO && deepLinkUrl === ''))) {
                const navigateUrlResp = await getNavigateUrl({
                    dunsNumber: '', DUNSList: dunsList, noDunsFlow: true, pendingDuns: false
                }).unwrap();
                window.open(navigateUrlResp.ssoUrl, '_self');
            }
            // Pending company flow
            else if (ENABLE_NEW_DPM_FEATURES && (isCompanyDropDownWithOutAnyVBOProducts || isCompanyDropDownOnlyAvailable) && deepLinkUrl === '') {
                const navigateUrlResp = await getNavigateUrl({
                    dunsNumber: '', DUNSList: dunsList, noDunsFlow: false, pendingDuns: true
                }).unwrap();
                window.open(navigateUrlResp.ssoUrl, '_self');
            }
            // Company dropdown selected company But DPM product is not available
            else if (ENABLE_NEW_DPM_FEATURES && isDunsSelected && deepLinkUrl === '' && !isProductDPM) {
                const navigateUrlResp = await getNavigateUrl({
                    dunsNumber: selectedCompanyDunsNumber || '', DUNSList: dunsList
                }).unwrap();
                window.open(navigateUrlResp.ssoUrl, '_self');
            }
            // Company dropdown selected company & DPM product is available
            else {
                window.open(deepLinkUrl, '_self');
            }
        };
        return (
            <>
                {ENABLE_NEW_DPM_FEATURES && (
                    <div className={isMobile ? 'w-[95%] mr-[5px] mt-[5px] rounded-[5px] box-border font-semibold inline-flex desktop:mt-0 desktop:p-2.5 desktop:ml-[5px] desktop:font-[unset] desktop:border-0 desktop:[&>*]:p-[8px_8px_10px] desktop:[&>*:last-child]:p-0 hover:desktop:bg-light-gray-content hover:desktop:border-transparent hover:desktop:border-0 hover:desktop:rounded-[5px] hover:border-l-[5px] hover:border-r-0 hover:border-t-0 hover:border-b-0 hover:border-light-gray-content hover:rounded-none border-solid' : 'no-underline flex flex-row justify-center items-center px-4 static w-auto h-[61px] text-dnb-cpl-box-shadow z-20 not-italic font-normal text-sm leading-5 tracking-[01.px] cursor-pointer'}>
                        <a
                            onClick={marketingHubLink}
                            rel="noopener noreferrer"
                            className="navigation-item"
                            target="_self"
                        >
                            <div className={isMobile ? 'text-dnb-cpl-box-shadow text-sm leading-5 h-[50px] desktop:h-5 px-[5px] flex items-center ml-5 mr-2.5' : ''}>
                                <Translate value="nav:marketing-hub" />
                            </div>
                        </a>
                    </div>
                )}
            </>
        );
    };

    const DesktopNavigation = useMemo(() => (
        <div className="flex mt-[3px]">
            <div className="no-underline flex flex-row justify-center items-center px-4 static w-auto h-[61px] text-dnb-cpl-box-shadow z-20 not-italic font-normal text-sm leading-5 tracking-[01.px] cursor-pointer">
                <CompanyDropdownList selectedCompanyData={handleSelectedCompanyData} />
            </div>
            <NavLink
                onClick={() => sendGA4ClickEvent('linkTrackingEvent', { linkTrackingName: 'Home tab clicked' })}
                to="/"
                isActive={() => location.pathname === '/'}
                activeClassName="no-underline flex flex-row justify-center items-center px-4 static w-auto h-[61px] text-dnb-cpl-box-shadow z-20 not-italic font-normal text-sm leading-5 tracking-[01.px] cursor-pointer text-[#0078a7] shadow-[inset_0_-2px_0] shadow-launch-text"
                className="no-underline flex flex-row justify-center items-center px-4 static w-auto h-[61px] text-dnb-cpl-box-shadow z-20 not-italic font-normal text-sm leading-5 tracking-[01.px] cursor-pointer"
            >
                <Translate value="nav:landing-page" />
            </NavLink>
            <CreditTab />
            {isCountryCodeUS(profileDetails.countryCode) && (
                <MarketingHubTab />)}
            {isDealsOffersEnabled
                && (
                    <a
                        onClick={() => sendGA4ClickEvent('linkTrackingEvent', { linkTrackingName: 'Deals and Offers tab clicked' })}
                        href="https://www.dnb.com/marketplace/product.html"
                        className="no-underline flex flex-row justify-center items-center px-4 static w-auto h-[61px] text-dnb-cpl-box-shadow z-20 not-italic font-normal text-sm leading-5 tracking-[01.px] cursor-pointer"
                        target="_blank"
                        rel="noreferrer noopener"
                    >
                        <Translate value="nav:deals-offers" />
                        <FontAwesomeIcon className="text-sm text-dnb-cpl-box-shadow ml-2.5 font-light" icon={faExternalLinkAlt} />
                    </a>
                )}
        </div>
    ), []);

    const ProfileAccountSettings = () => (
        <div>
            <hr className="mb-3 mx-3 desktop:hidden" />
            <div className={`w-[95%] desktop:m-[5px_5px_0] rounded-[5px] box-border font-semibold inline-flex desktop:p-[8px_8px_10px] desktop:font-[unset] desktop:border-0 desktop:[&>*]:p-[8px_8px_10px] desktop:[&>*:last-child]:p-0 hover:desktop:bg-light-gray-content hover:desktop:border-transparent hover:desktop:border-0 hover:desktop:rounded-[5px] hover:border-l-[5px] hover:border-r-0 hover:border-t-0 hover:border-b-0 hover:border-light-gray-content hover:rounded-none border-solid ${(isMobile && pathname === '/accountInfo/profile') ? 'border-l-[5px] border-r-0 border-t-0 border-b-0 border-launch-text bg-thumbnail-button-hover-blue rounded-r-[7px] rounded-l-none border-solid ml-0 self-start' : ''}`}>
                <Link to="/accountInfo/profile" data-testid="account">
                    <div className="text-dnb-cpl-box-shadow text-sm leading-5 items-center tracking-[0.1px] desktop:h-5 h-[50px] px-[5px] flex ml-5 mr-2.5">
                        <Translate value="account" />
                    </div>
                </Link>
            </div>
            <hr className="mt-3 mx-3 desktop:hidden" />
        </div>
    );

    const ChangePassword = () => (
        <div
            className={
                `w-[95%] desktop:m-[5px_5px_0] rounded-[5px] box-border font-semibold inline-flex desktop:p-[8px_8px_10px] desktop:font-[unset] desktop:border-0 desktop:[&>*]:p-[8px_8px_10px] desktop:[&>*:last-child]:p-0 hover:desktop:bg-light-gray-content hover:desktop:border-transparent hover:desktop:border-0 hover:desktop:rounded-[5px] hover:border-l-[5px] hover:border-r-0 hover:border-t-0 hover:border-b-0 hover:border-light-gray-content hover:rounded-none border-solid  ${!isMobile && 'hidden'}
        ${(isMobile && pathname === '/accountInfo/changePassword')
                    ? 'border-l-[5px] border-r-0 border-t-0 border-b-0 border-launch-text bg-thumbnail-button-hover-blue rounded-r-[7px] rounded-l-none border-solid ml-0 self-start' : ''}`
            }
        >
            <Link to="/accountInfo/changePassword" data-testid="changePassword">
                <div className="text-dnb-cpl-box-shadow text-sm leading-5 h-[50px] desktop:h-5 px-[5px] flex items-center ml-5 mr-2.5">
                    <Translate value="account-info-navbar:change-password" />
                </div>
            </Link>
        </div>
    );

    const MyOrders = () => (
        <div
            className={
                `w-[95%] desktop:m-[5px_5px_0] rounded-[5px] box-border font-semibold inline-flex desktop:p-[8px_8px_10px] desktop:font-[unset] desktop:border-0 desktop:[&>*]:p-[8px_8px_10px] desktop:[&>*:last-child]:p-0 hover:desktop:bg-light-gray-content hover:desktop:border-transparent hover:desktop:border-0 hover:desktop:rounded-[5px] hover:border-l-[5px] hover:border-r-0 hover:border-t-0 hover:border-b-0 hover:border-light-gray-content hover:rounded-none border-solid  ${!isMobile && 'hidden'} ${(isMobile && pathname === '/accountInfo/orders')
                    ? 'border-l-[5px] border-r-0 border-t-0 border-b-0 border-launch-text bg-thumbnail-button-hover-blue rounded-r-[7px] rounded-l-none border-solid ml-0 self-start' : ''}`
            }
        >
            <a
                onClick={() => sendGA4ClickEvent('linkTrackingEvent', { linkTrackingName: 'my orders launched' })}
                href={`${magentoUrl(language_code)}`}
                data-testid="orders"
            >
                <div className="text-dnb-cpl-box-shadow text-sm leading-5 h-[50px] desktop:h-5 px-[5px] flex items-center ml-5 mr-2.5">
                    <Translate value="account-info-navbar:orders" />
                </div>
            </a>
        </div>
    );

    const MySubscriptions = () => (
        <div
            className={`w-[95%] desktop:m-[5px_5px_0] rounded-[5px] box-border font-semibold inline-flex desktop:p-[8px_8px_10px] desktop:font-[unset] desktop:border-0 desktop:[&>*]:p-[8px_8px_10px] desktop:[&>*:last-child]:p-0 hover:desktop:bg-light-gray-content hover:desktop:border-transparent hover:desktop:border-0 hover:desktop:rounded-[5px] hover:border-l-[5px] hover:border-r-0 hover:border-t-0 hover:border-b-0 hover:border-light-gray-content hover:rounded-none border-solid  ${!isMobile && 'hidden'} ${(isMobile && pathname === '/accountInfo/subscriptions')
                ? 'border-l-[5px] border-r-0 border-t-0 border-b-0 border-launch-text bg-thumbnail-button-hover-blue rounded-r-[7px] rounded-l-none border-solid ml-0 self-start' : ''}`}
        >
            <a
                onClick={() => sendGA4ClickEvent('linkTrackingEvent', { linkTrackingName: 'my subscriptions launched' })}
                href={`${subscriptionMagentoUrl(language_code)}`}
                data-testid="subscriptions"
            >
                <div className="text-dnb-cpl-box-shadow text-sm leading-5 h-[50px] desktop:h-5 px-[5px] flex items-center ml-5 mr-2.5">
                    <Translate value="account-info-navbar:subscriptions" />
                </div>
            </a>
        </div>
    );
    const LegalTerms = () => (
        <div
            className={
                `w-[95%] desktop:m-[5px_5px_0] rounded-[5px] box-border font-semibold inline-flex desktop:p-[8px_8px_10px] desktop:font-[unset] desktop:border-0 desktop:[&>*]:p-[8px_8px_10px] desktop:[&>*:last-child]:p-0 hover:desktop:bg-light-gray-content hover:desktop:border-transparent hover:desktop:border-0 hover:desktop:rounded-[5px] hover:border-l-[5px] hover:border-r-0 hover:border-t-0 hover:border-b-0 hover:border-light-gray-content hover:rounded-none border-solid  ${!isMobile && 'hidden'} ${(isMobile && pathname === '/accountInfo/legal')
                    ? 'border-l-[5px] border-r-0 border-t-0 border-b-0 border-launch-text bg-thumbnail-button-hover-blue rounded-r-[7px] rounded-l-none border-solid ml-0 self-start' : ''}`
            }
        >
            <Link to="/accountInfo/legal" data-testid="legal">
                <div className="text-dnb-cpl-box-shadow text-sm leading-5 h-[50px] desktop:h-5 px-[5px] flex items-center ml-5 mr-2.5">
                    <Translate value="account-info-navbar:legal" />
                </div>
            </Link>
        </div>
    );

    const LearningCenter = () => (
        <div className="block w-[95%] desktop:m-[5px_5px_0] rounded-[5px] box-border font-semibold desktop:inline-flex desktop:p-[8px_8px_10px] desktop:font-[unset] desktop:border-0 desktop:[&>*]:p-[8px_8px_10px] desktop:[&>*:last-child]:p-0 hover:desktop:bg-light-gray-content hover:desktop:border-transparent hover:desktop:border-0 hover:desktop:rounded-[5px] hover:border-l-[5px] hover:border-r-0 hover:border-t-0 hover:border-b-0 hover:border-light-gray-content hover:rounded-none border-solid ">
            <a
                onClick={() => sendGA4ClickEvent('linkTrackingEvent', { linkTrackingName: 'learning center launched' })}
                href={`${learningCenterURL}`}
                target="_blank"
                data-testid="learning-enter"
                rel="noreferrer"
            >
                <div className="text-dnb-cpl-box-shadow text-sm leading-5 h-[50px] desktop:h-5 px-[5px] flex items-center ml-5 mr-2.5">
                    <Translate value="learning-center" />
                </div>
            </a>
        </div>
    );

    const CustomerSupport = () => (
        <div className="w-[95%] desktop:m-[5px_5px_0] rounded-[5px] box-border font-semibold inline-flex desktop:p-[8px_8px_10px] desktop:font-[unset] desktop:border-0 desktop:[&>*]:p-[8px_8px_10px] desktop:[&>*:last-child]:p-0 hover:desktop:bg-light-gray-content hover:desktop:border-transparent hover:desktop:border-0 hover:desktop:rounded-[5px] hover:border-l-[5px] hover:border-r-0 hover:border-t-0 hover:border-b-0 hover:border-light-gray-content hover:rounded-none border-solid ">
            <a
                onClick={() => sendGA4ClickEvent('linkTrackingEvent', { linkTrackingName: 'customer support launched' })}
                href={`${supportURL}`}
                data-testid="customer-support"
                target="_blank"
                rel="noreferrer"
            >
                <div className="text-dnb-cpl-box-shadow text-sm leading-5 h-[50px] desktop:h-5 px-[5px] flex items-center ml-5 mr-2.5">
                    <Translate value="customer-support" />
                </div>
            </a>
        </div>
    );

    const CancelRenewal = () => (
        <div className="w-[95%] desktop:m-[5px_5px_0] rounded-[5px] box-border font-semibold inline-flex desktop:p-[8px_8px_10px] desktop:font-[unset] desktop:border-0 desktop:[&>*]:p-[8px_8px_10px] desktop:[&>*:last-child]:p-0 hover:desktop:bg-light-gray-content hover:desktop:border-transparent hover:desktop:border-0 hover:desktop:rounded-[5px] hover:border-l-[5px] hover:border-r-0 hover:border-t-0 hover:border-b-0 hover:border-light-gray-content hover:rounded-none border-solid ">
            <a
                onClick={
                    () => sendGA4ClickEvent('linkTrackingEvent', { linkTrackingName: 'Cancel Renewal launched' })
                }
                href={`${getCancelRenewalURL(cancelRenewalURL)}${isCountryCodeUS(profileDetails.countryCode) ? cancelRenewalURLQueryParams : ''}`}
                data-testid="cancel-renewal"
                target={isCancelrenewalSupportThroughEmail ? '_top' : '_blank'}
                rel="noreferrer"
            >
                <div className="text-dnb-cpl-box-shadow text-sm leading-5 h-[50px] desktop:h-5 px-[5px] flex items-center ml-5 mr-2.5">
                    <Translate value="cancel-renewal" />
                </div>
            </a>
        </div>
    );

    const CancelSignOut = () => (
        <div className="w-[95%] desktop:m-[5px_5px_0] rounded-[5px] box-border font-semibold inline-flex desktop:p-[8px_8px_10px] desktop:font-[unset] desktop:border-0 desktop:[&>*]:p-[8px_8px_10px] desktop:[&>*:last-child]:p-0 hover:desktop:bg-light-gray-content hover:desktop:border-transparent hover:desktop:border-0 hover:desktop:rounded-[5px] hover:border-l-[5px] hover:border-r-0 hover:border-t-0 hover:border-b-0 hover:border-light-gray-content hover:rounded-none border-solid ">
            <Link to="/logout" data-testid="logout">
                <div className="text-dnb-cpl-box-shadow text-sm leading-5 h-[50px] desktop:h-5 px-[5px] flex items-center ml-5 mr-2.5">
                    <Translate value="sign-out" />
                </div>
            </Link>
        </div>
    );
    const MFAPage = () => (
        <div className="w-[95%] desktop:m-[5px_5px_0] rounded-[5px] box-border font-semibold inline-flex desktop:p-[8px_8px_10px] desktop:font-[unset] desktop:border-0 desktop:[&>*]:p-[8px_8px_10px] desktop:[&>*:last-child]:p-0 hover:desktop:bg-light-gray-content hover:desktop:border-transparent hover:desktop:border-0 hover:desktop:rounded-[5px] hover:border-l-[5px] hover:border-r-0 hover:border-t-0 hover:border-b-0 hover:border-light-gray-content hover:rounded-none border-solid ">
            <Link to="/mfa" data-testid="mfa">
                <div className="text-dnb-cpl-box-shadow text-sm leading-5 h-[50px] desktop:h-5 px-[5px] flex items-center ml-5 mr-2.5">
                    MFA Options
                    {/* <Translate value="mfa" /> */}
                </div>
            </Link>
        </div>
    );
    const pathname = window.location.pathname;

    const loc = useLocation();
    const [inAccSettings, setInAccSettings] = useState(loc.pathname.includes('accountInfo'));

    useEffect(() => {
        setInAccSettings(loc.pathname.includes('accountInfo'));
    }, [loc.pathname]);

    const showNotifications = () => {
        setShowNotification(!showNotification);
    };

    return (
        <>
            <nav id="topBar" className={`w-full h-[60px] min-h-[60px] bg-white rounded-none z-[15] flex items-center justify-center shadow-[0_1px_2px] shadow-box-shadow ${showMobileMenu ? 'mobile-overlay' : ''}`}>
                <section className="flex w-full">
                    <section className="desktop:w-[200px]">
                        <a
                            data-testid="dnb-logo"
                            className={`flex justify-center opacity-[1] relative top-0 ${isScreenWidthUnder600Pixel ? 'top-[15px]' : ''}`}
                            rel="noopener noreferrer"
                            href="/"
                        >
                            {isScreenWidthUnder600Pixel ? (
                                <DnbLogo logoName="mobileMyDnb" className="my-3 mx-4" />
                            ) : (
                                <div className="mydnb-logo-global">
                                    <DnbLogo className="flex justify-center opacity-[1] relative top-0" logoName="myDnb" />
                                </div>
                            )}
                        </a>

                    </section>
                    {isMobile && !inAccSettings
                        && (
                            <section className="my-3 mx-0 w-auto">
                                <div className="no-underline flex flex-row justify-center items-center px-4 static w-auto h-[61px] text-dnb-cpl-box-shadow z-20 font-normal not-italic text-sm leading-5 tracking-[0.1px]">
                                    <CompanyDropdownList selectedCompanyData={handleSelectedCompanyData} />
                                </div>
                            </section>
                        )}
                    <section
                        className={`flex flex-row w-full ${isScreenWidthUnder600Pixel ? 'pr-[21px] justify-end items-center' : (inAccSettings ? ' justify-end' : 'justify-end desktop:justify-between')}`}
                    >
                        {(!isMobile && !inAccSettings) && DesktopNavigation}

                        <div className="flex justify-end lg:items-baseline items-center">
                            {!diplomaProductLists.length ? '' : (
                                <div className="desktop:top-[17px] desktop:text-lg\! text-xl pt-[5px] relative text-active-color h-7 border-0 bg-transparent cursor-pointer flex flex-row items-center desktop:text-xl desktop:w-[23px] desktop:mr-11" onClick={() => { showNotifications(); }}>
                                    <BellNotification />
                                </div>
                            )}

                            <div className="profile-icon text-xl pt-[5px] relative mobile:right-2.5 text-active-color h-7 w-7 border-0 bg-transparent cursor-pointer flex flex-row items-center desktop:top-4 desktop:text-xl desktop:w-[23px] desktop:mr-11">
                                {!isScreenWidthUnder600Pixel && (
                                    <div aria-label="accountInfo" onClick={() => { isMobile && setShowMobileMenu(true); }}>
                                        <img src={icon} className="text-active-color relative left-1/4 desktop:left-0 desktop:top-0" alt="user-icon" />
                                    </div>
                                )}
                                {isScreenWidthUnder600Pixel && (
                                    <div onClick={() => { isMobile && setShowMobileMenu(true); }}>
                                        <img src={hamburger} style={{ color: '#6B6D6F' }} alt="account" className="text-active-color relative left-1/4 desktop:left-0 desktop:top-0" />
                                    </div>
                                )}
                                <div
                                    className={(showMobileMenu) ? 'fixed top-0 right-0 w-64 bg-white h-screen z-[11] border-0 rounded-lg opacity-100 visible overflow-y-scroll' : 'profile-desktop-menu absolute top-6 right-0 w-64 shadow bg-white h-screen desktop:h-auto z-[11] border-0 rounded-lg'}
                                    onClick={(event) => {
                                        event.stopPropagation();
                                    }}
                                >

                                    <div className="w-64 h-auto text-base bg-white rounded-[5px] overflow-hidden">
                                        {isMobile && (
                                            <button className="w-[80%] p-0 border border-white rounded-full bg-white self-end h-6 w-6 text-center leading-6 mt-5 mb-[15px] mx-5 text-[2rem] flex justify-end icon-cancel" onClick={() => setShowMobileMenu(!showMobileMenu)}>
                                                <img src={closeNoBackground} alt="Close" />
                                            </button>
                                        )}
                                        {!showSubMenu ? (
                                            <>
                                                {isMobile && (
                                                    <div onClick={toggleSubMenu} className={`block w-[95%] desktop:m-[5px_5px_0] rounded-[5px] box-border font-semibold desktop:inline-flex desktop:p-[8px_8px_10px] desktop:font-[unset] desktop:border-0 desktop:[&>*]:p-[8px_8px_10px] desktop:[&>*:last-child]:p-0 hover:desktop:bg-light-gray-content hover:desktop:border-transparent hover:desktop:border-0 hover:desktop:rounded-[5px] hover:border-l-[5px] hover:border-r-0 hover:border-t-0 hover:border-b-0 hover:border-light-gray-content hover:rounded-none border-solid  ${(isMobile && pathname === '/') ? 'border-l-[5px] border-r-0 border-t-0 border-b-0 border-launch-text bg-thumbnail-button-hover-blue rounded-r-[7px] rounded-l-none border-solid ml-0 self-start' : ''}`}>
                                                        <button data-testid="account">
                                                            <div className="text-dnb-cpl-box-shadow text-sm leading-5 h-[50px] desktop:h-5 px-[5px] flex items-center ml-5 mr-2.5">
                                                                <Translate value="nav:landing-page" />
                                                                <img src={greaterthanToggle} alt="Toggle" />
                                                            </div>

                                                        </button>
                                                    </div>
                                                )}
                                                {isMobile && (
                                                    <>
                                                        <CreditTab />
                                                        {isCountryCodeUS(profileDetails.countryCode) && (
                                                            <MarketingHubTab />)}
                                                    </>
                                                )}
                                                {isMobile && (
                                                    <>
                                                        {isDealsOffersEnabled
                                                            && (
                                                                <div className="w-[95%] desktop:m-[5px_5px_0] rounded-[5px] box-border font-semibold inline-flex desktop:p-[8px_8px_10px] desktop:font-[unset] desktop:border-0 desktop:[&>*]:p-[8px_8px_10px] desktop:[&>*:last-child]:p-0 hover:desktop:bg-light-gray-content hover:desktop:border-transparent hover:desktop:border-0 hover:desktop:rounded-[5px] hover:border-l-[5px] hover:border-r-0 hover:border-t-0 hover:border-b-0 hover:border-light-gray-content hover:rounded-none border-solid ">
                                                                    <a
                                                                        href="https://www.dnb.com/marketplace/product.html"
                                                                        className="navigation-item"
                                                                        target="_blank"
                                                                        rel="noreferrer noopener"
                                                                    >
                                                                        <div className="text-dnb-cpl-box-shadow text-sm leading-5 h-[50px] desktop:h-5 px-[5px] flex items-center ml-5 mr-2.5">
                                                                            <Translate value="nav:deals-offers" />
                                                                        </div>
                                                                    </a>
                                                                </div>
                                                            )}
                                                    </>
                                                )}
                                                {isMobile && (<span className="nav-divider" />)}
                                                {/* https://jira.aws.dnb.com/browse/CPL-3089
                                                            senarios for US,UK, IE, HU, CZ, CH, PL,CA updated in EXcel */}
                                                <ProfileAccountSettings />
                                                {(accountSettings.magento || !accountSettings.eb_dashboard) && <ChangePassword />}
                                                {accountSettings.magento && <MyOrders />}
                                                {accountSettings.magento && <MySubscriptions />}
                                                {(accountSettings.magento || !accountSettings.eb_dashboard) && <LegalTerms />}
                                                {isMobile && (<span className="nav-divider" />)}
                                                {isLearningCenterEnabled && <LearningCenter />}
                                                {isSupportEnabled && <CustomerSupport />}
                                                {
                                                    displayCancelLink(vboEntitlementList, credEntitlementList)
                                                    && CANCEL_RENEWAL && isCancelRenewalEnabled && <CancelRenewal />
                                                }
                                                {MFA_FACTOR && <MFAPage />}
                                                <CancelSignOut />
                                            </>
                                        ) : (
                                            <>
                                                <div className="w-[95%] desktop:m-[5px_5px_0] rounded-[5px] box-border font-semibold inline-flex desktop:p-[8px_8px_10px] desktop:font-[unset] desktop:border-0 desktop:[&>*]:p-[8px_8px_10px] desktop:[&>*:last-child]:p-0 hover:desktop:bg-light-gray-content hover:desktop:border-transparent hover:desktop:border-0 hover:desktop:rounded-[5px] hover:border-l-[5px] hover:border-r-0 hover:border-t-0 hover:border-b-0 hover:border-light-gray-content hover:rounded-none border-solid ">
                                                    <div className="text-dnb-cpl-box-shadow text-sm leading-5 h-[50px] desktop:h-5 px-[5px] flex items-center ml-5 mr-2.5" onClick={toggleSubMenu} data-testid="account">
                                                        <img src={lesserthanToggle} alt="Toggle" />
                                                        <Translate value="nav:back" />
                                                    </div>
                                                </div>
                                                {!isMobile && (<span className="nav-divider" />)}
                                                <div className="w-[95%] desktop:m-[5px_5px_0] rounded-[5px] box-border font-semibold inline-flex desktop:p-[8px_8px_10px] desktop:font-[unset] desktop:border-0 desktop:[&>*]:p-[8px_8px_10px] desktop:[&>*:last-child]:p-0 hover:desktop:bg-light-gray-content hover:desktop:border-transparent hover:desktop:border-0 hover:desktop:rounded-[5px] hover:border-l-[5px] hover:border-r-0 hover:border-t-0 hover:border-b-0 hover:border-light-gray-content hover:rounded-none border-solid ">
                                                    <div
                                                        className="text-dnb-cpl-box-shadow text-sm leading-5 h-[50px] desktop:h-5 px-[5px] flex items-center ml-5 mr-2.5 menu-bottom"
                                                        onClick={() => {
                                                            setShowSubMenu(false);
                                                            setShowMobileMenu(false); history.push('/');
                                                        }}
                                                        data-testid="account"
                                                    >
                                                        <Translate value="nav:my-apps" />
                                                    </div>
                                                </div>
                                                {enableNewLendioFeatures && userCountryCode === countryCodes.US && !inAccSettings
                                                    && (
                                                        <div className="block w-[95%] desktop:m-[5px_5px_0] rounded-[5px] box-border font-semibold desktop:inline-flex desktop:p-[8px_8px_10px] desktop:font-[unset] desktop:border-0 desktop:[&>*]:p-[8px_8px_10px] desktop:[&>*:last-child]:p-0 hover:desktop:bg-light-gray-content hover:desktop:border-transparent hover:desktop:border-0 hover:desktop:rounded-[5px] hover:border-l-[5px] hover:border-r-0 hover:border-t-0 hover:border-b-0 hover:border-light-gray-content hover:rounded-none border-solid ">
                                                            <Button
                                                                className="text-dnb-cpl-box-shadow text-sm leading-5 h-[50px] desktop:h-5 px-[5px] flex items-center ml-5 mr-2.5 menu-bottom"
                                                                onClick={handleIsSmallBusinessFinancingClicked}
                                                                data-testid="small-business-financing"
                                                            >
                                                                <Translate value="nav:small-business-financing" />
                                                            </Button>
                                                        </div>
                                                    )}
                                                {enableLiliFeatures && userCountryCode === countryCodes.US && !inAccSettings
                                                    && (
                                                        <div className="w-[95%] desktop:m-[5px_5px_0] rounded-[5px] box-border font-semibold inline-flex desktop:p-[8px_8px_10px] desktop:font-[unset] desktop:border-0 desktop:[&>*]:p-[8px_8px_10px] desktop:[&>*:last-child]:p-0 hover:desktop:bg-light-gray-content hover:desktop:border-transparent hover:desktop:border-0 hover:desktop:rounded-[5px] hover:border-l-[5px] hover:border-r-0 hover:border-t-0 hover:border-b-0 hover:border-light-gray-content hover:rounded-none border-solid ">
                                                            <Button
                                                                className="text-dnb-cpl-box-shadow text-sm leading-5 h-[50px] desktop:h-5 px-[5px] flex items-center ml-5 mr-2.5 menu-bottom"
                                                                onClick={handleIsSmallBusinessBankingClicked}
                                                                data-testid="small-business-banking"
                                                            >
                                                                <Translate value="nav:small-business-banking" />
                                                            </Button>
                                                        </div>
                                                    )}
                                                {enableNextInsuranceFeatures && userCountryCode === countryCodes.US && !inAccSettings
                                                    && (
                                                        <div className="w-[95%] desktop:m-[5px_5px_0] rounded-[5px] box-border font-semibold inline-flex desktop:p-[8px_8px_10px] desktop:font-[unset] desktop:border-0 desktop:[&>*]:p-[8px_8px_10px] desktop:[&>*:last-child]:p-0 hover:desktop:bg-light-gray-content hover:desktop:border-transparent hover:desktop:border-0 hover:desktop:rounded-[5px] hover:border-l-[5px] hover:border-r-0 hover:border-t-0 hover:border-b-0 hover:border-light-gray-content hover:rounded-none border-solid ">
                                                            <Button
                                                                className="text-dnb-cpl-box-shadow text-sm leading-5 h-[50px] desktop:h-5 px-[5px] flex items-center ml-5 mr-2.5 menu-bottom"
                                                                onClick={handleIsSmallBusinessInsuranceClicked}
                                                                data-testid="small-business-insurance"
                                                            >
                                                                <Translate value="nav:small-business-insurance" />
                                                            </Button>
                                                        </div>
                                                    )}
                                                {userCountryCode === countryCodes.US && !inAccSettings
                                                    && (
                                                        <>
                                                            <div>
                                                                <div className="relative w-[95%] desktop:m-[5px_5px_0] rounded-[5px] box-border font-semibold desktop:inline-flex desktop:p-[8px_8px_10px] desktop:font-[unset] desktop:border-0 desktop:[&>*]:p-[8px_8px_10px] desktop:[&>*:last-child]:p-0 hover:desktop:bg-light-gray-content hover:desktop:border-transparent hover:desktop:border-0 hover:desktop:rounded-[5px] hover:border-l-[5px] hover:border-r-0 hover:border-t-0 hover:border-b-0 hover:border-light-gray-content hover:rounded-none border-solid ">
                                                                    <Button
                                                                        className="text-dnb-cpl-box-shadow text-sm leading-5 h-[50px] desktop:h-5 px-[5px] flex items-center gap-2 ml-5 mr-2.5 menu-bottom"
                                                                        onClick={handleIsFundabilityScanClicked}
                                                                        data-testid="fundability-scan"
                                                                    >
                                                                        <Translate value="nav:fundability-scan" />
                                                                        <FontAwesomeIcon className="external-link-mobile-icon" icon={faExternalLinkAlt} color="#6B6D6F" />
                                                                    </Button>
                                                                    <div className="mobiletooltip-icon-container block">
                                                                        <InfoTooltip isDashboard={false} id="fundability-scan" ismobile={showMobileMenu} openTooltipId={openTooltipId} setOpenTooltipId={setOpenTooltipId} />
                                                                    </div>
                                                                </div>
                                                                <div className="relative w-[95%] desktop:m-[5px_5px_0] rounded-[5px] box-border font-semibold desktop:inline-flex desktop:p-[8px_8px_10px] desktop:font-[unset] desktop:border-0 desktop:[&>*]:p-[8px_8px_10px] desktop:[&>*:last-child]:p-0 hover:desktop:bg-light-gray-content hover:desktop:border-transparent hover:desktop:border-0 hover:desktop:rounded-[5px] hover:border-l-[5px] hover:border-r-0 hover:border-t-0 hover:border-b-0 hover:border-light-gray-content hover:rounded-none border-solid ">
                                                                    <Button
                                                                        className="text-dnb-cpl-box-shadow text-sm leading-5 h-[50px] desktop:h-5 px-[5px] flex items-center gap-2 ml-5 mr-2.5 menu-bottom"
                                                                        onClick={handleIsTaxAndAccountingClicked}
                                                                        data-testid="tax-and-accounting"
                                                                    >
                                                                        <Translate value="nav:tax-and-accounting" />
                                                                        <FontAwesomeIcon className="external-link-mobile-icon" icon={faExternalLinkAlt} color="#6B6D6F" />
                                                                    </Button>
                                                                    <div className="mobiletooltip-icon-container">
                                                                        <InfoTooltip isDashboard={false} id="tax-and-accounting" ismobile={showMobileMenu} openTooltipId={openTooltipId} setOpenTooltipId={setOpenTooltipId} />
                                                                    </div>
                                                                </div>
                                                                <div className="relative w-[95%] desktop:m-[5px_5px_0] rounded-[5px] box-border font-semibold desktop:inline-flex desktop:p-[8px_8px_10px] desktop:font-[unset] desktop:border-0 desktop:[&>*]:p-[8px_8px_10px] desktop:[&>*:last-child]:p-0 hover:desktop:bg-light-gray-content hover:desktop:border-transparent hover:desktop:border-0 hover:desktop:rounded-[5px] hover:border-l-[5px] hover:border-r-0 hover:border-t-0 hover:border-b-0 hover:border-light-gray-content hover:rounded-none border-solid ">
                                                                    <Button
                                                                        className="text-dnb-cpl-box-shadow text-sm leading-5 h-[50px] desktop:h-5 px-[5px] flex items-center gap-2 ml-5 mr-2.5 menu-bottom"
                                                                        onClick={handleIsLegalLLCFormationClicked}
                                                                        data-testid="legal-llc-formation"
                                                                    >
                                                                        <Translate value="nav:legal-llc-formation" />
                                                                        <FontAwesomeIcon className="external-link-mobile-icon" icon={faExternalLinkAlt} color="#6B6D6F" />
                                                                    </Button>
                                                                    <div className="mobiletooltip-icon-container">
                                                                        <InfoTooltip isDashboard={false} id="legal-llc-formation" ismobile={showMobileMenu} openTooltipId={openTooltipId} setOpenTooltipId={setOpenTooltipId} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>

                        </div>

                    </section>
                </section>
            </nav>
            {document.URL.includes('accountInfo') && <RoutingHeader goTo="/" text={<Translate value="go-to-portal" />} />}
        </>
    );
};

export default TopBarComponent;
